import i18n from 'i18next';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../../utilz/i18n';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentItrackStatus } from '../../hooks';

export const ShipmentItrackStatusSelect = ({
  placeholder = i18n.t('translation:default.fields.status.placeholder'),
  label = i18n.t('translation:default.fields.status.label'),
  rules = [],
  name,
  editMode,
  value,
  tooltip,
  margin = 'mb-0',
  singleLineMode,
  colon,
  onChange = () => {},
}) => {
  const { data: options = [], isLoading } = useGetShipmentItrackStatus();

  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <FormSelectBox
      loading={isLoading}
      options={[{ label: `--${t('translation:default.options.all')}--`, value: '**' }, ...options]}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      value={value}
      tooltip={tooltip}
      singleLineMode={singleLineMode}
      colon={colon}
      onChange={onChange}
    />
  );
};
